import { IState } from '../store';

export const selectDealRent = (state: IState) => state.dealRent;
